import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, createAllowance } from 'src/reducers/clients/allowances';
import { getItem, setItem, getItemErrors } from 'src/reducers/common/itemReducer';
import { getSelectOptions } from 'src/reducers/selectOptions';
import AllowanceEditingForm from './components/AllowanceEditingForm';

const initializeClientAllowanceItemId = clientAllowanceItems =>
  clientAllowanceItems.map(clientAllowanceItem => (clientAllowanceItem.value ? clientAllowanceItem.id : false));

let NewAllowanceForm = reduxForm({
  form: CLIENT_ALLOWANCE_FORM
})(AllowanceEditingForm);

const mapStateToProps = state => ({
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: {
    ...getItem(REDUCER_NAME, state),
    allowanceAmount: '0',
    allowanceAmountSecondHalf: '0',
    incomeTaxType: 'progressive_tax',
    clientAllowanceItemIds: initializeClientAllowanceItemId(getSelectOptions(state, 'clientAllowanceItems')),
  }
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(createAllowance(data));
  }
});

NewAllowanceForm = connect(mapStateToProps, mapDispatchToProps)(NewAllowanceForm);

const NewClientAllowance = ({ dispatch, values, match, payrollRulesGroup, leaves }) => {
  const { t } = useTranslation();
  const { payrollRulesGroupId } = match.params;
  dispatch(
    setItem(REDUCER_NAME, {
      ...values,
      motivationStep: [],
      paymentType: null,
      leaves,
      probationStep: [],
      motivationState: 'fulltime'
    })
  );
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">
          {t('features.ClientAllowances.NewClientAllowance.Provision_Deduction_items_Additional_Registration')}
        </h1>
        <div className="m-title-main-note">{payrollRulesGroup.name}</div>
      </div>
      <div className="l-wrap-m">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('features.ClientAllowances.NewClientAllowance.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item
              label={t('features.ClientAllowances.NewClientAllowance.salary_rule_group_list')}
              path={CLIENT_PAYROLL_RULES_GROUP_LIST}
            />
            <BreadCrumb.Item
              label={t('features.ClientAllowances.NewClientAllowance.provision_deduction_items_list')}
              path={`/clients/payroll_rules_groups/${payrollRulesGroupId}/allowances`}
            />
            <BreadCrumb.Item label={t('features.ClientAllowances.NewClientAllowance.provision_deduction_items_additional_registration')} />
          </BreadCrumb>
        </div>
        <NewAllowanceForm payrollRulesGroup={payrollRulesGroup} />
      </div>
    </div>
  );
};

export default connect()(NewClientAllowance);
